module.exports = __webpack_public_path__ + "img/adhesivo_ceramico.78abdb5d.png";